import { apiCallGeneric } from "./api-service.js";

const resolveResponseOrThrow = (response, endpoint, method) => {
    if (response?.status >= 400 || !response?.status) {
        const error = new Error(`${method} API Error [${endpoint}]`);
        error.response = response;
        throw error;
    }
    return response;
};

export const getApi = async (endpoint, params = {}, headers = {}) => {
    try {
        const options = { params };
        if (headers && Object.keys(headers).length > 0) {
            options.headers = headers;
        }
        const response = await apiCallGeneric("get", `${endpoint}`, null, options);
        resolveResponseOrThrow(response, endpoint, "GET");
        return response.data;
    } catch (error) {
        console.error(`GET API Error [${endpoint}]:`, error);
        throw error;
    }
};

export const deleteApi = async (endpoint, params = {}, headers = {}) => {
    try {
        const options = { params };
        if (headers && Object.keys(headers).length > 0) {
            options.headers = headers;
        }
        const response = await apiCallGeneric("delete", `${endpoint}`, null, options);
        resolveResponseOrThrow(response, endpoint, "DELETE");
        return response.data;
    } catch (error) {
        console.error(`DELETE API Error [${endpoint}]:`, error);
        throw error;
    }
};

export const postApi = async (endpoint, data = {}, headers = {}) => {
    try {
        const options = {};
        if (headers && Object.keys(headers).length > 0) {
            options.headers = headers;
        }
        const response = await apiCallGeneric("post", `${endpoint}`, data, options);
        resolveResponseOrThrow(response, endpoint, "POST");
        return response;
    } catch (error) {
        console.error(`POST API Error [${endpoint}]:`, error);
        throw error;
    }
};

export const putApi = async (endpoint, data = {}, headers = {}) => {
    try {
        const options = {};
        if (headers && Object.keys(headers).length > 0) {
            options.headers = headers;
        }
        const response = await apiCallGeneric("put", `${endpoint}`, data, options);
        resolveResponseOrThrow(response, endpoint, "PUT");
        return response.data;
    } catch (error) {
        console.error(`PUT API Error [${endpoint}]:`, error);
        throw error;
    }
};
